export const SettingsSaveBar = ({ dirty, saving, onSave, onDiscard }) => {
  if (!dirty) return null;
  return (
    <div className="sticky bottom-4 z-10 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-[#0052FF]/20 bg-white/95 p-4 shadow-xl backdrop-blur dark:border-[#0052FF]/30 dark:bg-[#111C33]/95" data-testid="org-settings-save-bar">
      <p className="text-sm font-semibold text-slate-700 dark:text-slate-200">You have unsaved changes.</p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onDiscard}
          disabled={saving}
          data-testid="org-settings-discard-btn"
          className="rounded-xl border border-slate-300 px-4 py-2 text-xs font-bold text-slate-600 hover:bg-slate-50 disabled:opacity-50 dark:border-white/15 dark:text-slate-300 dark:hover:bg-white/10"
        >
          Discard
        </button>
        <button
          type="button"
          onClick={onSave}
          disabled={saving}
          data-testid="org-settings-save-btn"
          className="rounded-xl bg-[#0052FF] px-5 py-2 text-xs font-bold text-white disabled:opacity-50"
        >
          {saving ? "Saving…" : "Save Changes"}
        </button>
      </div>
    </div>
  );
};
